import { render, staticRenderFns } from "./RcvScL.vue?vue&type=template&id=05deafa8"
import script from "./RcvScL.vue?vue&type=script&lang=js"
export * from "./RcvScL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports